interface JoinMeetingIconProps {
  className?: string;
  width?: number;
  height?: number;
}

export function JoinMeetingIcon({ className, width = 48, height = 49 }: JoinMeetingIconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M42.3359 0.5C45.464 0.500165 47.9998 3.03596 48 6.16406V42.8359C47.9998 45.964 45.464 48.4998 42.3359 48.5H5.66406C2.53596 48.4998 0.00016492 45.964 0 42.8359V6.16406C0.00016492 3.03596 2.53596 0.500165 5.66406 0.5H42.3359ZM23.9492 14.4844C23.1671 14.4844 22.5332 15.1183 22.5332 15.9004V24.0879H14.7998C14.0178 24.0879 13.384 24.722 13.3838 25.5039C13.3839 26.2859 14.0178 26.9199 14.7998 26.9199H22.5332V35.1084C22.5335 35.8903 23.1673 36.5244 23.9492 36.5244C24.731 36.5243 25.365 35.8902 25.3652 35.1084V26.9199H33.0986C33.8805 26.9197 34.5145 26.2858 34.5146 25.5039C34.5144 24.7221 33.8804 24.0881 33.0986 24.0879H25.3652V15.9004C25.3652 15.1184 24.7312 14.4845 23.9492 14.4844Z" fill="currentColor" />
    </svg>
  );
}
